import React, { useState, Suspense } from "react";

// Lazily load only the Editor component
const Editor = React.lazy(() => import("react-draft-wysiwyg").then((module) => ({ default: module.Editor })));

// Import these dependencies normally, as they are critical to the functioning of the component
import draftToHtml from "draftjs-to-html";
import { convertToRaw, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import ContentState from "draft-js/lib/ContentState";

// Ensure to include the CSS for the editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export function TextEditor({ valueRef, part, setPart, onBlur, onChange }) {
	if (!part) part = {};
	const [editorState, setEditorState] = useState(() => initializeEditorState(part));

	const handleEditorStateChange = (editorState) => {
		setEditorState(editorState);
		valueRef.current.value = draftToHtml(convertToRaw(editorState.getCurrentContent()));
		if ((valueRef.current.value === ('<p></p>'))
			|| (valueRef.current.value === ('<p></p>\n'))
		)
			valueRef.current.value = undefined;
		onChange && onChange(valueRef.current.value);
	};

	function initializeEditorState(part) {
		if (!part.value) return EditorState.createEmpty();
		const blocksFromHtml = htmlToDraft(part.value);
		const { contentBlocks, entityMap } = blocksFromHtml;
		const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
		return EditorState.createWithContent(contentState);
	}

	return (
		<Suspense fallback={<div>Loading editor...</div>}>
			<Editor
				onBlur={()=>{onBlur&&onBlur(valueRef.current.value)}}
				defaultEditorState={editorState}
				onEditorStateChange={handleEditorStateChange}
				wrapperClassName="wrapper-class"
				editorClassName="editor-class"
				toolbar={{
					fontSize: {
						options: [
							"50%",
							"75%",
							"90%",
							"100%",
							"110%",
							"120%",
							"125%",
							"150%",
							"175%",
							"200%",
						],
					},
					fontFamily: {
						options: [
							"lato-regular",
							"lato-light",
							"pt-sans-regular",
							"LeckerLiOne",
							"Inter",
							"Inter-semibold",
							"Inter-thin",
							"Inter-light",
							"Montserrat",
							"Montserrat-SemiBold",
						],
					},
				}}
			/>
		</Suspense>
	);
}
